import { render, staticRenderFns } from "./index6.vue?vue&type=template&id=c093e6b8&"
import script from "./index6.vue?vue&type=script&lang=js&"
export * from "./index6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports